import React, { useState, useEffect } from 'react'
import './css/AddUserModal.css'
import { url } from '../../constants/url'
import { toast } from 'react-toastify'

function AddUserModal(props) {
    const {
        open, setOpenAddUserModal, handleRegisterUser, developerName, setDeveloperName, capitalizeFirstLetter,
        setDeveloperNameError, developerNameError, developerEmail, setDeveloperEmail, setDeveloperEmailError,
        developerEmailError, developerRole, setDeveloperRole, setDeveloperRoleError, developerRoleError,
        developerPermission, setDeveloperPermission, setDeveloperPermissionError, developerPermissionError,
        handleDeveloperRegister, editModalOpen, setEditModalOpen, selectedUser, setSelectedUser, fetchRegisteredClientUser
    } = props

    const [userData, setUserData] = useState(null)

    const fetchEditUserData = async () => {
        if (!selectedUser) return;
        try {
            const response = await fetch(`${url}/fetchedituserdata?userId=${selectedUser}`, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
            });

            const data = await response.json();
            console.log(data)
            if (response.ok) {
                setDeveloperName(data.user?.name || "");
                setDeveloperEmail(data.user?.email || "");
                setDeveloperPermission(data.user?.permission || "")
                setDeveloperRole(data.user?.role || "");

            } else {
                console.error("Error:", data.message);
            }
        } catch (error) {
            console.error("Fetch error:", error);
        }
    };

    const handleUpdateUser = async () => {
        try {
            const response = await fetch(`${url}/editregistereduser`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({
                    userId: selectedUser,
                    name: developerName,
                    email: developerEmail,
                    role: developerRole,
                    permission: developerPermission
                }),
            });

            const data = await response.json();
            if (response.ok) {
                toast.success("User updated successfully", {
                    position: "top-right",
                    autoClose: 2500,
                    pauseOnHover: false,
                });
                setDeveloperName('')
                setDeveloperEmail('')
                setDeveloperRole('')
                setDeveloperPermission('')
                setEditModalOpen(false)
                setSelectedUser(null)
                fetchRegisteredClientUser()
            }
            if (response.status === 400) {
                toast.error("Invalid data", {
                    position: "top-right",
                    autoClose: 2500,
                    pauseOnHover: false,
                });
            }
            if (response.status === 403) {
                toast.error("Access denied", {
                    position: "top-right",
                    autoClose: 2500,
                    pauseOnHover: false,
                });
            }
        } catch (error) {
            console.error("Update error:", error);
        }
    };

    useEffect(() => {
        if (editModalOpen) {
            fetchEditUserData();
        }
    }, [selectedUser, editModalOpen]);

    if (!open && !editModalOpen) return null;

    return (
        <div className='add-user-modal'>
            <div className='add-user-modal-container'>
                <div className='add-user-modal-header'>
                    <h2>{editModalOpen ? "Edit User" : "Registration Portal"}</h2>
                    <button
                        className='close-modal-button'
                        onClick={() => {
                            if (editModalOpen) {
                                setEditModalOpen(false);
                                setDeveloperName('')
                                setDeveloperEmail('')
                                setDeveloperRole('')
                                setDeveloperPermission('')
                                setSelectedUser(null)
                            } else {
                                setOpenAddUserModal(false);
                                setDeveloperName('')
                                setDeveloperEmail('')
                                setDeveloperRole('')
                                setDeveloperPermission('')
                                setSelectedUser(null)
                            }
                        }}
                    >
                        X
                    </button>
                </div>
                <div className='wrap_register_form_div'>
                    <div className='add-user-modal-content'>
                        <div className='add-user-description'>
                            <p>
                                {editModalOpen
                                    ? "Update the user details below. Changes will be saved immediately."
                                    : "Register the user by entering the required details. Upon successful registration, a confirmation email will be sent to the provided email address."}
                            </p>
                        </div>

                        <div className='add-user-form'>
                            <div className='form-group'>
                                <label>Name *</label>
                                <input
                                    type="text"
                                    placeholder='Enter name'
                                    value={developerName || ""}
                                    onChange={(e) => {
                                        setDeveloperName(capitalizeFirstLetter(e.target.value));
                                        setDeveloperNameError("");
                                    }}
                                />
                                {developerNameError && <p>{developerNameError}</p>}
                            </div>

                            <div className='form-group'>
                                <label>E-mail address *</label>
                                <input
                                    type="email"
                                    placeholder="Email"
                                    value={developerEmail || ""}
                                    onChange={(e) => {
                                        setDeveloperEmail(e.target.value);
                                        setDeveloperEmailError("");
                                    }}
                                    disabled={editModalOpen} // keep email uneditable in edit
                                />
                                {developerEmailError && <p>{developerEmailError}</p>}
                            </div>

                            <div className='form-group user-role'>
                                <label>User Permission *</label>
                                <select
                                    value={developerPermission || ""}
                                    onChange={(e) => {
                                        setDeveloperPermission(e.target.value);
                                        setDeveloperPermissionError("");
                                    }}
                                >
                                    <option value="">Select</option>
                                    <option value="level 1">Executive Policy</option>
                                    <option value="level 2">Manager Policy</option>
                                    <option value="level 3">Lead Policy</option>
                                    <option value="level 4">Engineer Policy</option>
                                </select>
                                {developerPermissionError && <p>{developerPermissionError}</p>}
                            </div>

                            <div className='form-group user-role'>
                                <label>User Role *</label>
                                <input type='text' placeholder='User role' value={developerRole || ""} onChange={(e) => {
                                    setDeveloperRole(e.target.value);
                                    setDeveloperRoleError("");
                                }} />

                                {developerRoleError && <p>{developerRoleError}</p>}
                            </div>

                            <div className='submit-button'>
                                {editModalOpen ? (
                                    <button onClick={handleUpdateUser}>Update User</button>
                                ) : (
                                    <button onClick={handleDeveloperRegister}>Create Account</button>
                                )}
                            </div>
                        </div>
                    </div>
                    <div style={{ width: "1px", backgroundColor: "#000000", margin: "30px 20px" }} className='horizontal_line_user'></div>
                    <div className='add-user-modal-permission-content'>
                        <h4>User Permission</h4>
                        <div>
                            {developerPermission && developerPermission === 'level 1' && (
                                <>
                                    <p><strong>Executive Policy</strong> users have the ability to view all projects, create new projects, assign projects to others, manage users within projects, view all vulnerabilities across the organization, assign vulnerabilities to users, manage all organization users, manage roles and permissions, and access the chatbox.</p>
                                    <p>Example: CISO, CTO</p>
                                </>
                            )}
                            {developerPermission && developerPermission === 'level 2' && (
                                <>
                                    <p><strong>Manager Policy</strong> users have the ability to view all projects, create new projects, assign projects to others, manage users within projects, view all vulnerabilities across the organization, assign vulnerabilities to users, manage all organization users, manage roles and permissions, and access the chatbox.</p>
                                    <p>Example: Product Manager, Project Manager</p>
                                </>
                            )}
                            {developerPermission && developerPermission === 'level 3' && (
                                <>
                                    <p><strong>Lead Policy</strong> users have the ability to view only the projects assigned to them, manage users within those projects, view all vulnerabilities within their assigned projects, and assign vulnerabilities to other users.</p>
                                    <p>Example: Team Lead</p>
                                </>
                            )}
                            {developerPermission && developerPermission === 'level 4' && (
                                <>
                                    <p><strong>Engineer Policy</strong> users have the ability to view only the vulnerabilities assigned to them, update the status of those vulnerabilities, and add comments to them.</p>
                                    <p>Example: Product Developer, Infrastructure Engineer</p>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddUserModal
